import { Logo } from "./Logo";
import { DownloadQrCard } from "./DownloadQrCard";

// Primary public navigation links.
const LINKS = [
    { label: "Privacy Policy", href: "/privacy", testId: "footer-link-privacy" },
    { label: "Terms & Conditions", href: "/terms", testId: "footer-link-terms" },
    { label: "Safety", href: "/safety", testId: "footer-link-safety" },
    { label: "Child safety", href: "/child-safety", testId: "footer-link-child-safety" },
    { label: "Support", href: "/support", testId: "footer-link-support" },
    { label: "For venues", href: "/venue-kit", testId: "footer-link-venues" },
    { label: "Lunar for Events", href: "/events", testId: "footer-link-events" },
];

export const Footer = ({ showEvents = true }) => {
    const links = showEvents ? LINKS : LINKS.filter(({ href }) => href !== "/events");

    return (
        <footer data-testid="main-footer" className="border-t border-[#E5E3DC]">
            <div className="mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 sm:flex-row sm:items-center sm:justify-between">
                <div data-testid="footer-wordmark">
                    <Logo size={32} />
                </div>
                <div className="flex flex-col gap-4 sm:items-end">
                    <DownloadQrCard testId="footer-download-qr" />
                    <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Footer">
                        {links.map(({ label, href, testId }) => (
                            <a
                                key={label}
                                href={href}
                                data-testid={testId}
                                {...(href.startsWith("http")
                                    ? { target: "_blank", rel: "noopener noreferrer" }
                                    : {})}
                                className="text-sm text-[#5C5F58] transition-colors duration-200 hover:text-[#2C3618]"
                            >
                                {label}
                            </a>
                        ))}
                    </nav>
                </div>
            </div>
            <div className="mx-auto max-w-6xl px-6 pb-10">
                <p className="text-xs text-[#5C5F58]">
                    © {new Date().getFullYear()} Somerhill Group Ltd. Registered in England and
                    Wales. All rights reserved.
                </p>
            </div>
        </footer>
    );
};
